export default "__VITE_ASSET__C$UtcF7v__"